import { render, staticRenderFns } from "./BranchesDialog.vue?vue&type=template&id=ebf415e6"
import script from "./BranchesDialog.vue?vue&type=script&lang=js"
export * from "./BranchesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports